<template>
    <AppNavigation>
        <mdb-container fluid>
          <mdb-row>
            <mdb-col col="1"><mdb-btn @click="$router.back()" size="sm" color="primary"><i class="fas fa-arrow-left"></i></mdb-btn></mdb-col>
            <mdb-col col="11"><h1 class="h1-responsive">Dispute Order: {{order?order.order_number:""}}</h1></mdb-col>
          </mdb-row>
          <hr>
          <mdb-container>
            <!-- Copy from Order Detail Component -->
            <mdb-row>
                <mdb-col class="mb-3" col="6" v-if="this.order && this.order.service_id==1 && this.order.merchant.is_pb==1">
                    <div class="pb-remark">PB Order</div>
                </mdb-col>
                <mdb-col class="mb-3" col="6" v-if="this.order && this.order.service_id==1 && this.order.merchant.is_mart==1">
                    <div class="mart-remark">Mart Order</div>
                </mdb-col>
            </mdb-row>
            <mdb-row class="mb-3" v-if="order">
              <mdb-col md="6">
                <mdb-card>
                    <mdb-card-body>
                        <div style="border-bottom: 1px solid grey">Pick Up</div>
                        <div class="text-primary">{{this.order?this.order.pickup.name:""}}</div>
                        <div class="small">{{this.order?this.order.pickup.address:""}}</div>
                        <div class="small">Numbering: {{this.order?this.order.pickup.remarks:""}}</div>
                        <div class="small" v-if="this.order && this.order.service_id==1">{{this.order?this.order.merchant.contact_number:""}}</div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                            <span slot="tip">Google Map</span>
                            <a slot="reference" target="_blank" :href="`https://www.google.com/maps?q=${this.order.pickup.lat},${this.order.pickup.lng}`">
                                <i class="far fa-map"></i> Open Map
                            </a>
                        </mdb-tooltip>
                    </mdb-card-body>
                </mdb-card>
            </mdb-col>
            <mdb-col md="6">
                <mdb-card>
                    <mdb-card-body>
                        <div style="border-bottom: 1px solid grey">Deliver</div>
                        <div class="text-success">{{this.order?this.order.deliver.name:""}}</div>
                        <div class="small">{{this.order?this.order.deliver.address:""}}</div>
                        <div class="small">Unit/Tingkat: {{this.order?this.order.deliver.remarks:""}}</div>
                        <div class="small">Note to Rider: {{this.order?this.order.note_customer:""}}</div>
                        <div class="small">{{this.order?this.order.customer_user.phone_number:""}}</div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                            <span slot="tip">Google Map</span>
                            <a slot="reference" target="_blank" :href="`https://www.google.com/maps?q=${this.order.deliver.lat},${this.order.deliver.lng}`">
                                <i class="far fa-map"></i> Open Map
                            </a>
                        </mdb-tooltip>
                    </mdb-card-body>
                </mdb-card>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="order" class="mb-3">
              <mdb-col md="12">
                <mdb-card>
                  <mdb-card-body>
                      <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Order Information</h4>
                      <mdb-container fluid>
                          <mdb-row class="py-1" v-for="item in order.all_items" style="border-bottom: 1px solid grey" :key="item.id">
                              <mdb-col col="6" class="text">
                                  <div :class="{'text-danger': item.is_available==0}">
                                      {{item.allproduct.allcategory.name}}
                                  </div>
                                  <div class="font-weight-bold d-flex flex-column">
                                      <div v-if="order.service_id==2">{{item.allproduct.merchant.name}}</div>
                                      <div class="d-flex flex-row align-items-center" :class="{'text-danger': item.is_available==0}">
                                          {{item.name}} 
                                          <mdb-icon v-if="item.is_available==0" class="text-danger ml-1" icon="times" />
                                      </div>
                                  </div>
                                  <div style="font-size: 0.75rem" :class="{'text-danger': item.is_available==0}">
                                      {{item.allproduct.description}}
                                  </div>
                                  <div v-for="variety in item.std_variety" :key="variety.id">
                                      {{variety.name}}: <span v-for="option in variety.options" :key="option.name">
                                          <span v-if="option.checked">{{option.name}} ({{parseFloat(option.price).toFixed(2)}})</span>
                                      </span>
                                  </div>
                                  <div v-if="item.remarks" :class="{'text-danger': item.is_available==0}">Remarks: {{item.remarks}}</div>
                              </mdb-col>
                              <mdb-col col="6" class="text-right">
                                  <div class="text" :class="{'text-danger': item.is_available==0}">{{item.quantity}} items</div>
                                  <div class="text" :class="{'text-danger': item.is_available==0}">RM {{item.service_charge_node.amount}}</div>
                              </mdb-col>
                          </mdb-row>
                          <mdb-row class="py-1" style="border-bottom: 1px solid grey">
                            <mdb-col col="6" class="text font-weight-bold">Total Items</mdb-col>
                            <mdb-col col="6" class="text-right font-weight-bold">
                                {{this.order.item_quantity}}
                            </mdb-col>
                          </mdb-row>
                      </mdb-container>
                  </mdb-card-body>
                </mdb-card>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="this.order" class="mb-3">
                <mdb-col md="12">
                    <mdb-card>
                        <mdb-card-body>
                            <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Payment Information</h4>
                            <mdb-container fluid>
                                <mdb-row class="py-1">
                                    <mdb-col col="6" class="text">Subtotal</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.item_price)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" v-if="this.order.service_charge.tax_amount!='0.00'">
                                    <mdb-col col="6" class="text">Tax</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.service_charge.tax_amount)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1">
                                    <mdb-col col="6" class="text">Delivery Fees</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.deliver.service_charge_node.amount)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" v-if="this.order.service_charge.service_fee!='0.00'">
                                    <mdb-col col="6" class="text">Combine Fees</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.service_charge.service_fee)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" v-if="this.order.service_charge.promo_code_paid!='0.00'">
                                    <mdb-col col="6" class="text">Promo Discount ({{this.order.service_charge.promo_code?this.order.service_charge.promo_code.promo_code_config.code:""}})</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.service_charge.promo_code_paid)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row v-if="this.order.small_order_fee" class="py-1">
                                    <mdb-col col="6" class="text">Small Order Fee</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.small_order_fee.service_charge_node.amount)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" style="border-top: 1px solid #2E2E2E; border-bottom: 1px solid #2E2E2E">
                                    <mdb-col col="6" class="text font-weight-bold">Total</mdb-col>
                                    <mdb-col col="6" class="text-right font-weight-bold">
                                        RM {{parsePrice(this.order.service_charge.grand_total)}}
                                    </mdb-col>
                                </mdb-row>
                            </mdb-container>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
            <!-- !end of Copy -->

            <mdb-card class="mb-4">              
              <mdb-card-body>
                <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Dispute Information</h4>
                <mdb-row>
                  <mdb-col>
                    <select v-model="reason" class="browser-default custom-select">
                      <option disabled value="" selected>Select Reason *</option>
                      <option value="Exchange of Item">Exchange of Item</option>
                      <option value="Unsatisfactory Food Quality">Unsatisfactory Food Quality</option>
                      <option value="Food Packaging Damage (Merchant's Responsility)">Food Packaging Damage (Merchant's Responsility)</option>
                      <option value="Food Packaging Damage (Rider's Responsility)">Food Packaging Damage (Rider's Responsility)</option>
                      <option value="Wrong/Missing Item (Merchant's Responsility)">Wrong/Missing Item (Merchant's Responsility)</option>
                      <option value="Wrong/Missing Item (Rider's Responsility)">Wrong/Missing Item (Rider's Responsility)</option>
                      <option value="Food Not Delivered (Order Status: Completed)">Food Not Delivered (Order Status: Completed)</option>
                      <option value="Customer unreachable (COD)">Customer unreachable (COD)</option>
                      <option value="Rider Adjustment">Rider Adjustment</option>
                      <option value="Double Charge">Double Charge</option>
                      <option value="Others">Others</option>
                    </select>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col>
                    <mdb-input outline v-model="remark" type="textarea" label="Dispute Remark *" :rows="5"/>
                  </mdb-col>
                </mdb-row>
                <mdb-row class="mb-3">
                  <mdb-col v-for="(image,index) in images" v-bind:key="image" md="3" class="d-flex flex-column align-items-center">
                    <img class="waves-effect attachment-upload" :src="renderAttachment(image)" />
                    <mdb-btn class="delete-image-btn" @click="deleteAttachment(index)" color="danger" size="sm"><mdb-icon icon="times" /></mdb-btn>
                  </mdb-col>
                  <input multiple type="file" @change="attachmentUpload" id="document-upload" hidden />
                </mdb-row>
                <mdb-row>
                  <mdb-col col="12">
                    <mdb-spinner v-if="loading_upload" small />
                    <mdb-tooltip v-if="!loading_upload" trigger="hover" :options="{placement: 'top'}">
                      <span slot="tip">Attachments</span>
                      <a slot="reference">
                        <mdb-btn @click="showAttachmentUpload" color="primary" size="sm">
                          <mdb-icon far icon="images" /> Add Attachment
                        </mdb-btn>
                      </a>
                    </mdb-tooltip>
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>

            <!-- Action Section -->
            <mdb-row class="mb-4" v-if="reason">
              <mdb-col md="4">
                <mdb-card>
                  <mdb-view class="d-flex flex-center py-2" hover>
                    <a>
                      <img :src="require('@/assets/customer.png')" height="150" width="150"/>
                      <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                    </a>
                  </mdb-view>
                  <mdb-card-body>
                    <mdb-input type="checkbox" id="is_customer_compensate_voucher" v-model="is_customer_compensate_voucher" label="Compensate Voucher" />
                    <mdb-row v-if="is_customer_compensate_voucher">
                      <mdb-col col="12">
                        <mdb-input outline v-model="customer.compensate_voucher_amount" type="text" class="my-1 p-0 mx-0" label="Value of Voucher"/>
                      </mdb-col>
                    </mdb-row>
                    <mdb-input type="checkbox" id="is_customer_refund_cash" v-model="is_customer_refund_cash" label="Refund Cash" />
                    <mdb-row v-if="is_customer_refund_cash">
                      <mdb-col col="12">
                        <mdb-input outline v-model="customer.refund_cash_amount" type="text" class="my-1 p-0 mx-0" label="Refund Amount"/>
                      </mdb-col>
                    </mdb-row>
                    <hr />
                    <mdb-row>
                      <mdb-col col="12">
                        <mdb-input outline v-model="customer.remark" type="textarea" label="Customer Remark" :rows="3"/>
                      </mdb-col>
                    </mdb-row>
                  </mdb-card-body>
                </mdb-card>
              </mdb-col>
              <mdb-col md="4">
                <mdb-card>
                  <mdb-view class="d-flex flex-center py-2" hover>
                    <a>
                      <img :src="require('@/assets/merchant.png')" height="150" width="150"/>
                      <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                    </a>
                  </mdb-view>
                  <mdb-card-body>
                    <mdb-input type="checkbox" id="is_merchant_compensate_payout" v-model="is_merchant_compensate_payout" label="Compensate Merchant" />
                    <mdb-row v-if="is_merchant_compensate_payout">
                      <mdb-col col="12">
                        <mdb-input basic @keydown.enter.native="merchantAction('INPUT')" v-model="merchant.compensate_amount" type="text" class="my-1 p-0 mx-0">
                          <mdb-dropdown slot="prepend">
                            <mdb-dropdown-toggle color="primary" size="md" slot="toggle" class="z-depth-0">{{merchant_mdr?"MDR":"None"}}</mdb-dropdown-toggle>
                            <mdb-dropdown-menu>
                              <mdb-dropdown-item @click="merchantAction('MDR')">MDR</mdb-dropdown-item>
                              <mdb-dropdown-item @click="merchantAction('NONE_MDR')">None</mdb-dropdown-item>
                            </mdb-dropdown-menu>
                          </mdb-dropdown>
                        </mdb-input>
                      </mdb-col>
                    </mdb-row>
                    <mdb-input type="checkbox" id="is_merchant_penalty_payout" v-model="is_merchant_penalty_payout" label="Penalty Merchant" />
                    <mdb-row v-if="is_merchant_penalty_payout">
                      <mdb-col col="12">
                        <mdb-input basic @keydown.enter.native="merchantAction('INPUT')" v-model="merchant.penalty_amount" type="text" class="my-1 p-0 mx-0">
                          <mdb-dropdown slot="prepend">
                            <mdb-dropdown-toggle color="primary" size="md" slot="toggle" class="z-depth-0">{{merchant_mdr?"MDR":"None"}}</mdb-dropdown-toggle>
                            <mdb-dropdown-menu>
                              <mdb-dropdown-item @click="merchantAction('MDR')">MDR</mdb-dropdown-item>
                              <mdb-dropdown-item @click="merchantAction('NONE_MDR')">None</mdb-dropdown-item>
                            </mdb-dropdown-menu>
                          </mdb-dropdown>
                        </mdb-input>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-1">
                      <mdb-col col="12" class="text-center">
                        <mdb-btn size="sm" color="success" @click="merchantAction('ADD_PAYOUT')">Add Merchant Payout</mdb-btn>
                        <mdb-btn size="sm" color="danger" @click="merchantAction('DEDUCT_PAYOUT')">Deduct Merchant Payout</mdb-btn>
                      </mdb-col>
                    </mdb-row>
                    <hr />
                    <mdb-row>
                      <mdb-col col="12">
                        <mdb-input outline v-model="merchant.remark" type="textarea" label="Merchant Remark" :rows="3"/>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row v-if="merchant.mdr_amount">
                      <mdb-col class="text-center font-weight-bold" col="12">
                        Total {{merchant.operator=="+"?"Compensate":"Penalty"}} RM {{merchant.mdr_amount}} 
                      </mdb-col>
                    </mdb-row>
                  </mdb-card-body>
                </mdb-card>
              </mdb-col>
              <mdb-col v-if="order && order.partner_user_id" md="4">
                <mdb-card>
                  <mdb-view class="d-flex flex-center py-2" hover>
                    <a>
                      <img :src="require('@/assets/rider.png')" height="150" width="150"/>
                      <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                    </a>
                  </mdb-view>
                  <mdb-card-body>
                    <mdb-input type="checkbox" id="is_partner_compensate_payout" v-model="is_partner_compensate_payout" label="Compensate Rider" />
                    <mdb-row v-if="is_partner_compensate_payout">
                      <mdb-col col="12">
                        <mdb-input outline @keydown.enter.native="partnerAction('INPUT')" v-model="partner.compensate_amount" type="text" class="my-1 p-0 mx-0" label="Compensate Rider Amount"/>
                      </mdb-col>
                    </mdb-row>
                    <mdb-input type="checkbox" id="is_partner_penalty_payout" v-model="is_partner_penalty_payout" label="Penalty Rider" />
                    <mdb-row v-if="is_partner_penalty_payout">
                      <mdb-col col="12">
                        <mdb-input outline @keydown.enter.native="partnerAction('INPUT')" type="text" v-model="partner.penalty_amount" class="my-1 p-0 mx-0" label="Penalty Rider Amounnt"/>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-1">
                      <mdb-col col="12" class="text-center">
                        <mdb-btn size="sm" color="success" @click="partnerAction('ADD_PAYOUT')">Add Rider Payout</mdb-btn>
                        <mdb-btn size="sm" color="danger" @click="partnerAction('DEDUCT_PAYOUT')">Deduct Rider Payout</mdb-btn>
                      </mdb-col>
                    </mdb-row>
                    <hr />
                    <mdb-row>
                      <mdb-col col="12">
                        <mdb-input outline v-model="partner.remark" type="textarea" label="Rider Remark" :rows="3"/>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row v-if="partner.amount">
                      <mdb-col class="text-center font-weight-bold" col="12">
                        Total {{partner.operator=="+"?"Compensate":"Penalty"}} RM {{partner.amount}} 
                      </mdb-col>
                    </mdb-row>
                  </mdb-card-body>
                </mdb-card>
              </mdb-col>
            </mdb-row>
            <!-- End of Action Section -->
            <mdb-row class="py-5" v-if="reason">
              <mdb-col col="12" class="d-flex flex-row justify-content-end">
                <mdb-btn @click="confirmationDispute" color="primary">Submit Dispute</mdb-btn>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-container>
        <ConfirmationModal :text="confirmation_text" :visible="confirmation_modal" :close="closeModal" title="Confirm Submit Dispute?" :submit="submitDispute" />
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbBtn, mdbRow, mdbCol, mdbCard, mdbCardBody,  mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbDropdownItem,
  mdbInput, mdbSpinner, mdbIcon, mdbTooltip, mdbView, mdbMask } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {fileUploadAjax, ajax} from '../js/ajax';
import {APP_FILE_URL} from '../js/config';
import {getColor} from '../js/colors';
import {validateNumber, validateRequired} from '../js/validation';
import ConfirmationModal from '../components/ConfirmationModal';

export default {
  name: 'order_dispute',
  components: {
    mdbContainer,mdbBtn, mdbRow, mdbCol, mdbView, mdbMask,
    mdbInput, mdbSpinner, mdbIcon, mdbTooltip, ConfirmationModal,
    AppNavigation, mdbCard, mdbCardBody, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbDropdownItem
  },
  data: ()=>({
    confirmation_modal: false,
    confirmation_text: "",
    order: null,
    loading:false,
    images: [],
    loading_upload: false,
    remark: "",
    reason: "",

    //control
    is_customer_compensate_voucher: false,
    is_customer_refund_cash: false,

    is_merchant_penalty_payout: false,
    is_merchant_compensate_payout: false,
    deduct_merchant_payout:false,
    add_merchant_payout: false,
    merchant_mdr: false,
    merchant_mdr_rate: 0,

    is_partner_compensate_payout: false,
    is_partner_penalty_payout: false,
    partner_payout: 0,
    add_partner_payout: false,
    deduct_partner_payout: false,

    //data
    customer: {
      compensate_voucher_amount: "",
      refund_cash_amount: "",
      remark: "",
      operator: "",
    },
    merchant: {
      penalty_amount: "",
      compensate_amount: "",
      mdr_amount: "",
      remark: "",
      operator: ""
    },
    partner: {
      compensate_amount: "",
      penalty_amount: "",
      remark: "",
      operator: "",
      amount: ""
    },
  }),
  methods: {
    showAttachmentUpload(){
      document.getElementById("document-upload").click();
    },
    renderAttachment(image=null){
      return image?APP_FILE_URL+image:require('@/assets/picture.png');
    },
    attachmentUpload(event){
      this.loading_upload=true;
      fileUploadAjax({
        url: "admin/upload_dispute_attachments",
        data: {event: event.target.files},
        complete: ()=>this.loading_upload=false,
        success: result=>{
          this.images=this.images.concat(result.data);
        },
        isShowAlert: true
      }, this)
    },
    deleteAttachment(index){
      var temp=[...this.images];
      temp.splice(index, 1);
      this.images=temp;
    },
    submitDispute(){
      //chec
      this.loading=true;
      ajax({
        url: "admin/submit_service_order_dispute",
        data: {
          order_number: this.order.order_number,
          service_order_id: this.order.id,
          remark: this.remark,
          images: this.images,
          reason: this.reason,
          is_customer_compensate_voucher: this.is_customer_compensate_voucher,
          is_customer_refund_cash: this.is_customer_refund_cash,
          is_merchant_penalty_payout: this.is_merchant_penalty_payout,
          is_merchant_compensate_payout: this.is_merchant_compensate_payout,
          is_partner_compensate_payout: this.is_partner_compensate_payout,
          is_partner_penalty_payout: this.is_partner_penalty_payout,

          deduct_merchant_payout:this.deduct_merchant_payout,
          add_merchant_payout: this.add_merchant_payout,
          merchant_mdr: this.merchant_mdr,
          merchant_mdr_rate: this.merchant_mdr_rate,          
          add_partner_payout: this.add_partner_payout,
          deduct_partner_payout: this.deduct_partner_payout,

          customer: this.customer,
          merchant: this.merchant,
          partner: this.partner,
        },
        complete: ()=>this.loading=false,
        success: ()=>{
          this.$router.push({ name: "dispute_order" })
          this.$notify.success({message: "Order Dispute had been Recorded.", position:'top right', timeOut: 5000});
        },
      }, this)
    },
    getColor(text){
      return getColor(text);
    },
    parsePrice(price){
      return parseFloat(price).toFixed(2);
    },
    merchantAction(action){
      if(this.is_merchant_penalty_payout && !validateNumber(this.merchant.penalty_amount)){
        this.$notify.error({message: "Merchant Penalty Amount Invalid", position:'top right', timeOut: 5000});
        return false;
      }
      if(this.is_merchant_compensate_payout && !validateNumber(this.merchant.compensate_amount)){
        this.$notify.error({message: "Merchant Compensate Amount Invalid", position:'top right', timeOut: 5000});
        return false;
      }
      var merchant_payout=this.order.service_charge.merchant_payout;
      switch(action){
        case "ADD_PAYOUT":{
          this.is_merchant_penalty_payout=false;
          this.is_merchant_compensate_payout=false;
          this.add_merchant_payout=true;
          this.deduct_merchant_payout=false;
          this.merchant_mdr=false;
          let temp = {...this.merchant};
          temp.penalty_amount="";
          temp.compensate_amount=merchant_payout;
          temp.mdr_amount=merchant_payout;
          temp.operator="+";
          this.merchant=temp;
          break;
        }
        case "DEDUCT_PAYOUT":{
          this.is_merchant_penalty_payout=false;
          this.is_merchant_compensate_payout=false;
          this.add_merchant_payout=false;
          this.deduct_merchant_payout=true;
          this.merchant_mdr=false;
          let temp = {...this.merchant};
          temp.penalty_amount=merchant_payout;
          temp.compensate_amount="";
          temp.mdr_amount=merchant_payout;
          temp.operator="-";
          this.merchant=temp;
          break;
        }
        case "NONE_MDR": {
          this.add_merchant_payout=false;
          this.deduct_merchant_payout=false;
          this.merchant_mdr=false;
          let operator=this.is_merchant_compensate_payout?"+":"-";
          let amount=this.is_merchant_compensate_payout?this.merchant.compensate_amount:this.merchant.penalty_amount;
          let temp = {...this.merchant};
          temp.mdr_amount=parseFloat(amount).toFixed(2);
          temp.operator=operator;
          this.merchant=temp;
          break;
        }
        case "MDR": {
          this.add_merchant_payout=false;
          this.deduct_merchant_payout=false;
          this.merchant_mdr=true;
          //calculate mdr Amount
          let amount=this.is_merchant_compensate_payout?this.merchant.compensate_amount:this.merchant.penalty_amount;
          let operator=this.is_merchant_compensate_payout?"+":"-";
          let after_amount=amount * this.merchant_mdr_rate;
          let temp = {...this.merchant};
          temp.mdr_amount=parseFloat(after_amount).toFixed(2);
          temp.operator=operator;
          this.merchant=temp;
          break;
        }
        case "INPUT": {
          if(this.merchant.compensate_amount){
            if(this.merchant_mdr){
              let temp={...this.merchant}
              temp.mdr_amount=parseFloat(this.merchant.compensate_amount * this.merchant_mdr_rate).toFixed(2);
              this.merchant=temp;
            }else{
              let temp={...this.merchant}
              temp.mdr_amount=parseFloat(this.merchant.compensate_amount).toFixed(2);
              this.merchant=temp;
            }
          }else
            if(this.merchant.penalty_amount){
              if(this.merchant_mdr){
                let temp={...this.merchant}
                temp.mdr_amount=parseFloat(this.merchant.penalty_amount * this.merchant_mdr_rate).toFixed(2);
                this.merchant=temp;
              }else{
                let temp={...this.merchant}
                temp.mdr_amount=parseFloat(this.merchant.penalty_amount).toFixed(2);
                this.merchant=temp;
              }
            }
          break;
        }
      }
    },
    partnerAction(action){
      if(this.is_partner_compensate_payout && !validateNumber(this.partner.compensate_amount)){
        this.$notify.error({message: "Rider Compensate Amount Invalid", position:'top right', timeOut: 5000});
        return false;
      }
      if(this.is_partner_penalty_payout && !validateNumber(this.partner.penalty_amount)){
        this.$notify.error({message: "Rider Penalty Amount Invalid", position:'top right', timeOut: 5000});
        return false;
      }
      switch(action){
        case "ADD_PAYOUT":{
          this.is_partner_compensate_payout=false;
          this.is_partner_penalty_payout=false;
          this.add_partner_payout=true;
          this.deduct_partner_payout=false;
          let temp={...this.partner}
          temp.compensate_amount=this.partner_payout;
          temp.penalty_amount="";
          temp.operator="+";
          temp.amount=this.partner_payout;
          this.partner=temp;
          break;
        }
        case "DEDUCT_PAYOUT":{
          this.is_partner_compensate_payout=false;
          this.is_partner_penalty_payout=false;
          this.add_partner_payout=false;
          this.deduct_partner_payout=true;
          let temp={...this.partner}
          temp.compensate_amount="";
          temp.penalty_amount=this.partner_payout;
          temp.operator="-";
          temp.amount=this.partner_payout;
          this.partner=temp;
          break;
        }
        case "INPUT": {
          this.add_partner_payout=false;
          this.deduct_partner_payout=false;
          if(this.is_partner_penalty_payout){
            let temp={...this.partner}
            temp.amount=this.partner.penalty_amount;
            this.partner=temp;
            break;
          }else if(this.is_partner_compensate_payout){
            let temp={...this.partner}
            temp.amount=this.partner.compensate_amount;
            this.partner=temp;
          }
        }
      }
    },
    closeModal(){
      this.confirmation_modal=false;
    },
    confirmationDispute(){
      var validation=true;
      var count=0;
      if(!validateRequired(this.reason)){
        this.$notify.error({message: "Please Select Reason", position: 'top right', timeOut: 5000})
        validation=false;
        count++;
      }
      if(!validateRequired(this.remark)){
        this.$notify.error({message: "Dispute Remark cannot be empty", position: 'top right', timeOut: 5000})
        validation=false;
        count++;
      }
      // if(this.images.length==0){
      //   this.$notify.error({message: "Please upload Attachments.", position: 'top right', timeOut: 5000})
      //   validation=false;
      //   count++;
      // }
      if(this.is_customer_compensate_voucher && !validateNumber(this.customer.compensate_voucher_amount)){
        this.$notify.error({message: "Hi kawan, Compensate Amount macam tak betul. Sila Check ya.", position: 'top right', timeOut: 5000})
        validation=false;
        count++;
      }
      if(this.is_customer_refund_cash && !validateNumber(this.customer.refund_cash_amount)){
        this.$notify.error({message: "Hi kawan, Refund Amount macam tak betul. Sila Check ya.", position: 'top right', timeOut: 5000})
        validation=false;
        count++;
      }
      if(this.is_merchant_penalty_payout && !validateNumber(this.merchant.penalty_amount)){
        this.$notify.error({message: "Hi kawan, Merchant Penalty Amount macam tak betul. Sila Check ya.", position: 'top right', timeOut: 5000})
        validation=false;
        count++;
      }
      if(this.is_merchant_compensate_payout && !validateNumber(this.merchant.compensate_amount)){
        this.$notify.error({message: "Hi kawan, Merchant Compensate Amount macam tak betul. Sila Check ya.", position: 'top right', timeOut: 5000})
        validation=false;
        count++;
      }
      if(this.is_partner_compensate_payout && !validateNumber(this.partner.compensate_amount)){
        this.$notify.error({message: "Hi kawan, Rider Compensate Amount macam tak betul. Sila Check ya.", position: 'top right', timeOut: 5000})
        validation=false;
        count++;
      }
      if(this.is_partner_penalty_payout && !validateNumber(this.partner.penalty_amount)){
        this.$notify.error({message: "Hi kawan, Rider Penalty Amount macam tak betul. Sila Check ya.", position: 'top right', timeOut: 5000});
        validation=false;
        count++;
      }
      if(validation){
        this.confirmation_modal=true;
      }else{
        if(count > 4){
          this.$notify.error({message: "Too many errors. Please Check betul betul kawan. 😡", position: 'top right', timeOut: 5000});
        }
      }
    }
  },
  watch: {
    is_customer_compensate_voucher(val){
      if(val){
        this.is_customer_refund_cash=false;
      }
    },
    is_customer_refund_cash(val){
      if(val){
        this.is_customer_compensate_voucher=false;
      }
    },
    is_merchant_penalty_payout(val){
      if(val){
        this.is_merchant_compensate_payout=false;
        this.deduct_merchant_payout=false;
        this.add_merchant_payout=false;
        var temp={...this.merchant};
        temp.penalty_amount="";
        temp.compensate_amount="";
        temp.mdr_amount="";
        temp.operator="";
        this.merchant=temp;
      }
    },
    is_merchant_compensate_payout(val){
      if(val){
        this.deduct_merchant_payout=false;
        this.add_merchant_payout=false;
        this.is_merchant_penalty_payout=false;
        var temp={...this.merchant};
        temp.penalty_amount="";
        temp.compensate_amount="";
        temp.mdr_amount="";
        temp.operator="";
        this.merchant=temp;
      }
    },
    is_partner_compensate_payout(val){
      if(val){
        this.is_partner_penalty_payout=false;
        this.add_partner_payout=false;
        this.deduct_merchant_payout=false;
        let temp={...this.partner}
        temp.compensate_amount="";
        temp.penalty_amount="";
        temp.operator="+";
        temp.amount="";
        this.partner=temp;
      }
    },
    is_partner_penalty_payout(val){
      if(val){
        this.is_partner_compensate_payout=false;
        this.add_partner_payout=false;
        this.deduct_merchant_payout=false;
        let temp={...this.partner}
        temp.compensate_amount="";
        temp.penalty_amount="";
        temp.operator="-";
        temp.amount="";
        this.partner=temp;
      }
    },
  },
  mounted: function(){
    let string_json=sessionStorage.getItem("focus_order", null);
    this.order=JSON.parse(string_json);
    this.merchant_mdr_rate= 1 - this.order.merchant.commission;
    if(this.order && this.order.partner_user_id){
      this.partner_payout=this.order.partner_user.partner_profile.payout_fixed;
    }
  }
}
</script>

<style scoped>
.pb-remark{
    background-color: #E91E63;
    color: #fff;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 20px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.mart-remark{
    background-color: #4caf50;
    color: #fff;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    display: flex;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.attachment-upload{
  height: 200px;
  width: 200px;
  object-fit: contain;
}

.delete-image-btn{
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
</style>
